import { createAction, createReducer } from '@reduxjs/toolkit';

export type TestVariation = 'off' | 'control' | 'on';

export type OptimizelyDecisionsState = Record<string, TestVariation>;

const setOptimizelyDecisions = createAction<OptimizelyDecisionsState>('optimizelyDecisions/set');

const optimizelyDecisionsReducer = createReducer<Record<string, TestVariation>>(
  {},
  {
    [setOptimizelyDecisions.type]: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  }
);

export { optimizelyDecisionsReducer, setOptimizelyDecisions };
